module.exports = __webpack_public_path__ + "img/popup_button7_normal.8257f07d.png";